import { createFileRoute } from '@tanstack/react-router'
import { E2ETestingPage } from '@/pages/e2e-testing'

export const Route = createFileRoute('/_authenticated/e2e-testing')({
  staticData: { title: 'E2E Testing' },
  component: E2ETestingPage,
})
